/** @format */

import {UnArchiveDesign} from '../../actions/unarchive_design_modal';
import React from 'react';

// styles
import './action_column.scss';

export const ActionColumn = ({designOrder}) => {
    const viewInvoicePath = `/account/orders/preview-current-invoice/${designOrder.cart_id}`;

    return (
        <div className="action-column-71bv">
            <div className="artwork-column-71bv__table-cell">
                <div>
                    <a
                        className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                        rel="noopener noreferrer"
                        href={viewInvoicePath}
                        target="_blank">
                        <i className={'fa fa-eye'} />
                        <u>Invoice</u>
                    </a>
                    <UnArchiveDesign designOrder={designOrder} />
                </div>
            </div>
        </div>
    );
};
